import React from 'react';
import styles from './ScenarioItem.module.css';
import { ScenarioDefinitionListResponse } from '../../api/types/scenario';

/**
 * Props interface for the ScenarioItem component
 */
interface ScenarioItemProps {
  scenario: ScenarioDefinitionListResponse;
  onClick: (scenario: ScenarioDefinitionListResponse) => void;
}

/**
 * Shared component for displaying a scenario item in the explore view
 * Used by both mobile and desktop views
 * Displayed as a horizontal card with text overlay on the image
 */
const ScenarioItem: React.FC<ScenarioItemProps> = ({ scenario, onClick }) => {
  // Add a timestamp for cache-busting
  const timestamp = Date.now();
  
  // Create a cache-busted image URL
  const imageUrl = scenario.icon 
    ? `${scenario.icon}?t=${timestamp}` 
    : '/media/default-scenario.png';
    
  return (
    <div 
      className={styles.scenarioItem}
      onClick={() => onClick(scenario)}
      role="button"
      tabIndex={0}
      aria-label={`View ${scenario.display_name}`}
    >
      <div className={styles.itemImage}>
        <img src={imageUrl} alt={scenario.display_name} />
      </div>
      <div className={styles.itemContent}>
        <h3 className={styles.displayName}>{scenario.display_name}</h3>
        <p className={styles.tagline}>{scenario.tagline}</p>
      </div>
    </div>
  );
};

// Wrap with React.memo to prevent re-renders when props haven't changed
export default React.memo(ScenarioItem); 